import React from "react";

const REGIONS = ["Global", "USA", "India", "Europe", "Asia"];
const ASSETS = [
  { id: "indices", label: "Indices" },
  { id: "stocks", label: "Stocks" },
  { id: "crypto", label: "Crypto" },
  { id: "forex", label: "Forex" },
  { id: "commodities", label: "Commodities" },
  { id: "bonds", label: "Bonds" },
];

function Chip({ active, onClick, children, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`px-3 py-1.5 text-xs mono uppercase tracking-[0.18em] border transition-colors duration-150 ${
        active
          ? "bg-white text-black border-white"
          : "bg-transparent text-white/60 border-white/15 hover:border-white/40 hover:text-white"
      }`}
    >
      {children}
    </button>
  );
}

export default function FiltersBar({ region, assetClass, onRegion, onAssetClass }) {
  return (
    <div className="bg-surface border-y border-white/10 px-4 md:px-6 py-3 flex flex-col md:flex-row gap-3 md:items-center" data-testid="filters-bar">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="overline mr-1">Region</span>
        {REGIONS.map((r) => (
          <Chip key={r} active={region === r} onClick={() => onRegion(r)} testid={`filter-region-${r}`}>
            {r}
          </Chip>
        ))}
      </div>
      <div className="hidden md:block w-px h-6 bg-white/10 mx-2" />
      <div className="flex items-center gap-2 flex-wrap">
        <span className="overline mr-1">Asset</span>
        {ASSETS.map((a) => (
          <Chip key={a.id} active={assetClass === a.id} onClick={() => onAssetClass(a.id)} testid={`filter-asset-${a.id}`}>
            {a.label}
          </Chip>
        ))}
      </div>
    </div>
  );
}
